import { create } from 'zustand';
import { User } from 'firebase/auth';
import { auth } from '../config/firebase';
import { useInvoiceStore } from './invoiceStore';
import { adminApi } from '../lib/api';

interface AuthState {
  user: User | null;
  loading: boolean;
  showLoginModal: boolean;
  isAuthenticated: boolean;
  isAdmin: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  openLoginModal: () => void;
  closeLoginModal: () => void;
  logout: () => Promise<void>;
  checkAdminStatus: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  showLoginModal: false,
  isAuthenticated: false,
  isAdmin: false,
  setUser: (user) => set({
    user,
    isAuthenticated: !!user,
  }),
  setLoading: (loading) => set({ loading }),
  openLoginModal: () => set({ showLoginModal: true }),
  closeLoginModal: () => set({ showLoginModal: false }),
  checkAdminStatus: async () => {
    try {
      console.log('[Auth Store] Checking admin status...');
      const { isAdmin } = await adminApi.checkStatus();
      console.log('[Auth Store] Admin status response:', { isAdmin });
      set({ isAdmin });
    } catch (error) {
      console.error('[Auth Store] Failed to check admin status:', error);
      set({ isAdmin: false });
    }
  },
  logout: async () => {
    try {
      await auth.signOut();
      set({
        user: null,
        isAuthenticated: false,
        isAdmin: false
      });

      // Reset store and settings
      useInvoiceStore.getState().resetStore();

      // Clear all local storage
      localStorage.removeItem('dutchinvoice_local_settings');
      localStorage.removeItem('dutchinvoice_local_invoices');
    } catch (error) {
      console.error('Logout error:', error);
    }
  }
})); 